import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Constants
import { PAGE_PATHS } from '../../../constants';

/**
 * Хук useInvitesTerms меняет url, а вместе с ним и активный таб в блоке "Семья в билайне"
 */
export const useInvitesTerms = ({ invites, isLoading }) => {
  const history = useHistory();

  useEffect(() => {
    if (!invites?.length && !isLoading) {
      history.push(PAGE_PATHS.terms);
    }
  }, [isLoading, invites]);
};
